import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from '../../types/utils';
import { ToastContainerProps } from '../../types/components';

/**
 * A container for displaying toast notifications
 */
function ToastContainer({ toasts, title }: ToastContainerProps) {
  const { t } = useTranslation();
  
  return (
    <div className="toast-container position-fixed bottom-0 end-0 p-3" data-testid="toast-container">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`toast ${toast.isVisible ? 'show' : ''} shadow-sm`}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className={`toast-header text-white bg-${toast.type}`}>
            <strong className="me-auto">{title || t('common.notification')}</strong>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              data-bs-dismiss="toast"
            ></button>
          </div>
          <div className="toast-body">
            {toast.message}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ToastContainer; 